import { Command } from '../Command';
import { generateDefault } from '../../../lib/utils';
import { commandList } from '../../../lib/command-list';
import {
  validSettingKey,
  validSettingData,
  validStorageSections
} from '../../../lib/constants';
import { Setting } from '../../models/Setting';

const RequestDeviceInfoCommand = Command.extend({}).defaultTo(
  generateDefault({
    action: commandList.REQUEST_DEVICE_INFO
  })
);

const RequestExitCommand = Command.extend({}).defaultTo(
  generateDefault({
    action: commandList.REQUEST_EXIT
  })
);

const RequestTokenCommand = Command.extend({
  detail: {
    refresh: Boolean
  }
}).defaultTo(
  generateDefault({
    action: commandList.REQUEST_TOKEN,
    detail: {
      refresh: false
    }
  })
);

const RequestInstalledAppsCommand = Command.extend({}).defaultTo(
  generateDefault({
    action: commandList.REQUEST_INSTALLED_APPS
  })
);

const RequestHasFeatureCommand = Command.extend({
  detail: {
    key: String
  }
}).defaultTo(
  generateDefault({
    action: commandList.REQUEST_HAS_FEATURE
  })
);

const RequestSettingCommand = Command.extend({
  detail: {
    key: String
  }
}).defaultTo(
  generateDefault({
    action: commandList.REQUEST_SETTING
  })
);

const UpdateSettingCommand = Command.extend({
  detail: Setting
}).defaultTo(
  generateDefault({
    action: commandList.UPDATE_SETTING
  })
);

const RequestReloadCommand = Command.extend({}).defaultTo(
  generateDefault({
    action: commandList.REQUEST_RELOAD
  })
);

const CheckRebootCommand = Command.extend({}).defaultTo(
  generateDefault({
    action: commandList.CHECK_REBOOT
  })
);

const CheckIfStorageEnoughCommand = Command.extend({
  detail: {
    section: Object.values(validStorageSections)
  }
}).defaultTo(
  generateDefault({
    action: commandList.CHECK_IF_STORAGE_ENOUGH
  })
);

const SendHttpRequestCommand = Command.extend({
  detail: {
    url: String,
    method: String,
    useDeviceInfo: Boolean,
    appendAccountInfo: [Boolean],
    params: [Object, undefined]
  }
}).defaultTo(
  generateDefault({
    action: commandList.SEND_HTTP_REQUEST
  })
);

export {
  RequestDeviceInfoCommand,
  RequestExitCommand,
  RequestTokenCommand,
  RequestInstalledAppsCommand,
  RequestHasFeatureCommand,
  RequestSettingCommand,
  UpdateSettingCommand,
  RequestReloadCommand,
  CheckRebootCommand,
  CheckIfStorageEnoughCommand,
  SendHttpRequestCommand
};
